
import * as Components from "./Pufflava"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "pufflava"
}

